<template>
  <basic-container>
    <a-time></a-time>
      <el-collapse-transition>
    <el-form
      v-show="searchBoxFlag"
      label-width="100px"
      size="small"
      v-model="form"
      label-position="right"
      inline
    >
      <el-row span="24">
       
<!-- 
            <div class="reset-form-item-content">
          <el-form-item label="创建时间:" label-width="150px" style="width: 100%; display: flex">

              <div style="width: 48%;display:inline-block;">
                <el-date-picker
                  style="width: 100%"
                  v-model="searchform.timeStart"
                  value-format="yyyy-MM-dd HH-mm-ss"
                  type="datetime"
                  placeholder="开始时间"
                >
                </el-date-picker>
              </div>
              <div style="width: 3%;display:inline-block;">
                -
              </div>
              <div style="width: 48%;display:inline-block;">
                <el-date-picker
                  style="width: 100%"
                  v-model="searchform.timeEnd"
                  value-format="yyyy-MM-dd HH-mm-ss"
                  type="datetime"
                  placeholder="结束时间"
                >
                </el-date-picker>
              </div>
          </el-form-item>
              </div>
      
        -->
        <!-- <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="" style="display: flex;width: 100%;">
            <el-button
              type="primary"
              size="small"
              @click="advanceSearch"
              style="flex: 2; text-align: right;margin-left: 10px;float:right"
              icon="el-icon-search"
              >高级搜索</el-button
            >
           
          </el-form-item>
              </div>
        </el-col> -->
      </el-row>
      <el-row>
            <div class="reset-form-item-content">
        <el-form-item label="工单状态" label-width="120px" style="display: flex;width: 100%">
          <div name="workStatusRadio">
            <el-radio-group
              v-model="searchform.orderStatus"
              @change="workStatusChange"
            >
              <el-radio-button
                :border="false"
                v-for="(item, index) in workStatusList_"
                :key="index"
                :label="item.dictKey"
                >{{ item.dictValue + "(" + item.count + ")" }}</el-radio-button
              >
            </el-radio-group>
            <el-button
              type="primary"
              size="small"
              @click="advanceSearch"
              style="flex: 2; text-align: right;margin-left: 10px;float:right"
              icon="el-icon-search"
              >高级搜索</el-button
            >
          </div>
          
        </el-form-item>
          </div>
      </el-row>
<!-- 
      <el-row>
            <div class="reset-form-item-content">
        <el-form-item label="创建视角" label-width="120px" style="display: flex;width: 100%">
          <div name="orderAngleRadio">
            <el-radio-group
              v-model="searchform.orderAngle"
              @change="orderAngleChange"
            >
              <el-radio-button
                v-for="(item, index) in orderAngleList"
                :key="index"
                :label="item.dictKey"
                >{{ item.dictValue }}</el-radio-button
              >
              <el-radio-button label="">全部</el-radio-button>
            </el-radio-group>
          </div>
        </el-form-item>
          </div>
      </el-row> -->

      <el-row>
            <div class="reset-form-item-content">
        <el-form-item
        label-width="120px"
          label="服务类型"
          style="width: 100%; display: flex"
        >
          <div name="moduleTypeRadio">
            <el-radio-group
              v-model="searchform.moduleType"
              @change="moduleTypeChange"
              style=""
            >
              <el-radio-button
                v-for="(item, index) in moduleTypeList_"
                :key="index"
                :label="item.dictKey"
                >{{ item.dictValue }}</el-radio-button
              >
              <el-radio-button label="">全部</el-radio-button>
            </el-radio-group>
          </div>
        </el-form-item>
          </div>
      </el-row>

      <el-row>
            <div class="reset-form-item-content">
        <el-form-item
          label="服务子类型"
        label-width="120px"
          style="width: 100%; display: flex"
        >
          <div name="subModuleTypeRadio">
            <el-radio-group
              v-model="searchform.subModuleId"
              @change="subModuleTypeChange"
              style=""
            >
              <el-radio-button
                v-for="(item, index) in subModuleList"
                :key="index"
                :label="item.id"
                >{{ item.name }}</el-radio-button
              >
              <el-radio-button label="">全部</el-radio-button>
            </el-radio-group>
          </div>
        </el-form-item>
          </div>
      </el-row>
    </el-form>
      </el-collapse-transition>
      <el-drawer
        title="高级搜索"
        :visible.sync="advanceSearchFlag"
        :direction="rtl"
        :modal='false'
        size='384px'
        id="hr2023320"
        :modal-append-to-body='false'
        @close="advanceSearchClose">
        <div >
          <el-form
        style="margin-right: 20px;"  
        label-width="100px"
        size="small"
        v-model="form"
        label-position="right"
        inline
        >
        <el-row span="24">
        <el-col span="24">
            <div class="reset-form-item-content">
          <el-form-item label="项目名称:" label-width="150px" style="width: 100%; display: flex">
            <el-select
              style="width: 100%; flex: 1"
              v-model="searchform.projectId"
              placeholder="项目名称"
              size="small"
              @change="changeHandler"
            >
              <el-option
                v-for="(item, index) in projectIdList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            </div>
        </el-col>
        <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="需求部门:" label-width="150px" style="width: 100%; display: flex">

            <div style="width: 100%; flex: 1">
              <avue-input-tree
                style="width: 100%"
                default-expand-all
                :props="{ label: 'title', value: 'key' }"
                :dicData="searchDeptTreeData"
                v-model="searchform.deptId"
                placeholder="需求部门"
                type="tree"
                :dic="searchDeptTreeData"
              ></avue-input-tree>
            </div>
          </el-form-item>
            </div>
        </el-col>
        <el-col span="24">
            <div class="reset-form-item-content">
          <el-form-item label="需求描述:" label-width="150px" style="width: 100%; display: flex">
            <el-input
              v-model="searchform.description"
              size="small"
              placeholder="需求描述"
              clearable
              style="width: 100%; flex: 1"
            ></el-input>
          </el-form-item>
            </div>
        </el-col>
        <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="需求人:" label-width="150px" style="width: 100%; display: flex">
            <div style="width: 100%; flex: 1">
              <el-input
                v-model="searchform.requireManName"
                placeholder="需求人"
                clearable
              ></el-input>
            </div>

          </el-form-item>
            </div>
        </el-col>

        <el-col span="24">

        <div class="reset-form-item-content">
        <el-form-item label="创建时间:" label-width="150px" style="width: 100%; display: flex">

          <div style="width: 48%;display:inline-block;">
            <el-date-picker
              style="width: 100%"
              v-model="searchform.timeStart"
              value-format="yyyy-MM-dd HH-mm-ss"
              type="datetime"
              placeholder="开始时间"
            >
            </el-date-picker>
          </div>
          <div style="width: 3%;display:inline-block;">
            -
          </div>
          <div style="width: 48%;display:inline-block;">
            <el-date-picker
              style="width: 100%"
              v-model="searchform.timeEnd"
              value-format="yyyy-MM-dd HH-mm-ss"
              type="datetime"
              placeholder="结束时间"
            >
            </el-date-picker>
          </div>
        </el-form-item>
          </div>
        </el-col>

        <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="紧急程度:" label-width="150px" style="width: 100%;display: flex">
            <el-select
            placeholder="紧急程度"
              v-model="searchform.urgentLevel"
              style="width: 100%; "
              clearable
            >
              <el-option
                v-for="(item, index) in urgentLevelList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
            </div>
        </el-col>
        <el-col span="24">
            <div class="reset-form-item-content">
          <el-form-item label="工单编号:" label-width="150px" style="width: 100%; display: flex">
            <el-input
              v-model="searchform.code"
              size="small"
              placeholder="工单编号"
              clearable
              style="width: 100%; flex: 1"
            ></el-input>
          </el-form-item>
            </div>
        </el-col>
     
        <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="服务项目分数:" label-width="150px" style="display: flex;width:100%;">
            <el-input v-model="searchform.scoreStart" type="number" clearable  maxlength="4" style="width:48%;"></el-input>
            <div style="display:inline-block;width:4%;text-align:center;">-</div>
            <el-input style="width:48%;" v-model="searchform.scoreEnd"  type="number" clearable maxlength="4"></el-input>
          </el-form-item>
            </div>
        </el-col>
       
        <el-col span="24" >
          <el-form-item label="工单评价:" label-width="150px" style="display: flex;width:100%;">
            <el-select
              clearable
              placeholder="工单评价"
              v-model="searchform.qualifyFlag"
              style="width: 100%; "
              
            >
              <el-option
                v-for="(item, index) in evaluateList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="24">
            <div class="reset-form-item-content">
          <el-form-item label="执行人:" label-width="150px" style="width: 100%;display: flex">
            <el-input
              style="width: 100%;"
              v-model="searchform.handerName"
              clearable
              placeholder="执行人"
            ></el-input>
          </el-form-item>
            </div>
        </el-col>
        <el-col span="24" >
            <div class="reset-form-item-content">
          <el-form-item label="协同人:" label-width="150px" style="width: 100%; display: flex">

            <el-input
              style="width: 100%; flex: 1"
              v-model="searchform.cooperateUserNames"
              placeholder="协同人"
              clearable
            ></el-input>
          </el-form-item>
            </div>
        </el-col>
       
        
        
        
      </el-row>
      </el-form>
      <div style="    text-align: right;margin-right: 20px;">
        <el-button
              type="primary"
              size="small"
              @click="searchChange"
              style=" margin-right: 20px;"
              icon="el-icon-search"
              >搜 索</el-button
            >
            <el-button

            size="small"
            @click="searchReset"
            style=""
            icon="el-icon-delete"
            >清 空</el-button
            >
            
    </div>
        </div>
      </el-drawer>
    <!-- v-if="reWrite" -->
    <avue-crud
    v-loading="crudLoading"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      @sort-change="sortChange"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @resetForm="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuRight">
        <div style="line-height:32px;margin-right:10px;">
              <el-checkbox v-model="refreshChecked" @change="changeRefreshChecked">每60s自动刷新</el-checkbox>

        </div>

             <wq-showHidden style="order:8" :column.sync="option.column" :moduleType="601" ></wq-showHidden>

              <el-button  style="order:10" size="small" icon="el-icon-search" circle @click="openSearchBox"
              >
              </el-button>
      </template>

      <template slot-scope="scope" slot="menuLeft">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="addOrderHandler()"
          >新 增</el-button
        >

            <wq-exportData :moduleType="601" @exportExcel="exportExcel"></wq-exportData>
      </template>
      <template slot="amount" slot-scope="scope">
        {{tool.money_format_allowvoid(scope.row.amount)}}
      </template>
<!--      icon="el-icon-view"-->
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.viewBtn"
          @click="openCourse(scope.row)"
          >详 情</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="(scope.row.moduleType == 7 || scope.row.moduleType == 12 || scope.row.moduleType == 13) && permissionList.editBtn && scope.row.workStatus >=6 && scope.row.workStatus <=8 "
          @click="openCourse(scope.row,'edit')"
          >编 辑</el-button
        >
        <!-- v-if="scope.row.workStatus === " -->
        <el-button
          type="text"
          size="small"
          v-if="
            permission.order_designate && parseInt(scope.row.workStatus) == 1 && parseInt(scope.row.approveFlag) == 0
          "
          icon="el-icon-thumb"
          @click="appointHandler(scope.row)"
          >派单</el-button
        >
        <el-button
          type="text"
          size="small"
          v-if="permission.order_rob && parseInt(scope.row.workStatus) == 1 && parseInt(scope.row.approveFlag) == 0"
          icon="el-icon-phone-outline"
          @click="orderGrabbingHandler(scope.row)"
          >抢单</el-button
        >
        <!-- <el-button
          type="text"
          size="small"
          v-if="searchform.orderStatus== 1||searchform.orderStatus== 2||searchform.orderStatus== 3||searchform.orderStatus== 4"
          icon="el-icon-phone-outline"
          @click="orderPressingHandler(scope.row)"
          >催办</el-button
        > -->
      </template>
      <template slot="description" slot-scope="scope">
        <el-tooltip class="item" effect="dark" :content="scope.row.description" placement="top">
          <div class="txtOver">{{ scope.row.description }}</div>
        </el-tooltip>
      </template>
      <template slot="areaName" slot-scope="scope">
        <el-tooltip class="item" effect="dark" :content="scope.row.areaName" placement="top">
          <div class="txtOver">{{ scope.row.areaName }}</div>
        </el-tooltip>
      </template>
      <template slot="areaIdSearch">
        <el-select
          v-model="searchform.areaId"
          placeholder="请选择存放区域"
          clearable
          @clear="clear"
          style="width: 100%"
          ref="connectSelect"
        >
          <el-option
            :value="form.areaId"
            show-all-levels
            :label="form.areaName"
          >
            <el-tree
              node-key="id"
              :data="treeFormAreaData"
              :props="treeProps"
              ref="tree"
              :load="editAreaLazyLoadTree"
              lazy
              @node-click="editAreaNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="workStatus" slot-scope="scope">
        <el-tag type="success">{{
          tool.getDictionaryValue(
            workStatusList,
            "dictValue",
            "dictKey",
            scope.row.workStatus
          )
        }}</el-tag>
      </template>
      <template slot="urgentLevel" slot-scope="scope">
        <el-tag
          :type="
            scope.row.urgentLevel == 1
              ? 'success'
              : scope.row.urgentLevel == 2
              ? 'warning'
              : 'danger'
          "
          >{{
            tool.getDictionaryValue(
              urgentLevelList,
              "dictValue",
              "dictKey",
              scope.row.urgentLevel
            )
          }}</el-tag
        >
      </template>
      <template slot="moduleType" slot-scope="scope">
        <el-tag type="success">{{
          tool.getDictionaryValue(
            moduleTypeList_,
            "dictValue",
            "dictKey",
            scope.row.moduleType
          )
        }}</el-tag>
      </template>
      <template slot="approveFlag" slot-scope="scope">
        <el-tag
          :type="
            scope.row.approveFlag == 0
              ? 'success'
              : scope.row.approveFlag == 1
              ? 'warning'
              : 'danger'
          "
        >{{
          tool.getDictionaryValue(
            approveFlagList,
            "dictValue",
            "dictKey",
            scope.row.approveFlag
          )
        }}</el-tag>
      </template>
      <template slot="timeoutFlag" slot-scope="scope">
        <el-tag
          :type="
            scope.row.timeoutFlag == 0
              ? 'success'
              : scope.row.timeoutFlag == 1
              ? 'danger'
              : 'warning'
          "
        >{{
          tool.getDictionaryValue(
          timeoutFlagList,
          "dictValue",
          "dictKey",
          scope.row.timeoutFlag
          )
          }}</el-tag>
      </template>

    </avue-crud>
    <courseCleanKeeping
    v-if="courseCleanKeepingFlag"
      ref="courseCleanKeeping"
      @refresh="onLoad"
    ></courseCleanKeeping>
    <courseEquipmentInspection

    v-if="courseEquipmentInspectionFlag"
      ref="courseEquipmentInspection"
      @refresh="onLoad"
      @addReportRepair="addReportRepair"
    ></courseEquipmentInspection>

    <courseComprehensiveInspection
    v-if="courseComprehensiveInspectionFlag"
      ref="courseComprehensiveInspection"
      @refresh="onLoad"
    ></courseComprehensiveInspection>

    <courseEquipmentMaintenance

    v-if="courseEquipmentMaintenanceFlag"
      ref="courseEquipmentMaintenance"
      @refresh="onLoad"
    ></courseEquipmentMaintenance>
    <courseUsecar

    v-if="courseUsecarFlag"
    ref="courseUsecar" @refresh="onLoad"></courseUsecar>
    <courseComplaints
    v-if="courseComplaintsFlag"
      ref="courseComplaints"
      @refresh="onLoad"
    ></courseComplaints>
    <courseEscort
    v-if="courseEscortFlag"
    ref="courseEscort" @refresh="onLoad"></courseEscort>
    <courseRepair

    v-if="courseRepairFlag"
    ref="courseRepair" @refresh="onLoad"></courseRepair>
    <!-- 信息设备维修 -->
    <courseRepairInformation v-if="courseRepairInformationFlag" ref="courseRepairInformation" @refresh="onLoad"></courseRepairInformation>
    <!-- 医疗设备维修 -->
    <courseRepairLogistics v-if="courseRepairLogisticsFlag" ref="courseRepairLogistics" @refresh="onLoad"></courseRepairLogistics>
    <courseSecurity

    v-if="courseSecurityFlag"
    ref="courseSecurity" @refresh="onLoad"></courseSecurity>
    <courseTransport

    v-if="courseTransportFlag"
    ref="courseTransport" @refresh="onLoad"></courseTransport>
    <courseAreaInspection

    v-if="courseAreaInspectionFlag"
      ref="courseAreaInspection"
      @refresh="onLoad"
    ></courseAreaInspection>

    <!--  -->
    <el-dialog
      class="add-dialog"
      title="新增工单"
      width="65%"
      top="60px"
      :fullscreen="dialogFull"
      :visible.sync="dialogOrderCreateBoxVisible"
      append-to-body
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
    <template slot="title">
                <div class="avue-crud__dialog__header">
                        <span class="el-dialog__title">
                            新增工单
                        </span>
                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                </div>
      </template>
      <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
      <!-- 通用表单项PYC -->
        <el-form
          size="small"
          v-if="dialogOrderCreateBoxVisible"
          label-width="150px"
          ref="addForm"
          id="addForm"
          :rules="addFormRules"
          :model="addForm"
          inline
        >
          <el-row span="24">
            <el-col span="8">
              <div class="reset-form-item-content">

                <el-form-item label="来源" prop="source" style="display: flex">
                  <el-select v-model="addForm.source"
                  placeholder="请选择 来源"
                style="width:100%;">
                    <el-option
                      v-for="(item, index) in orderRequireSourceList"
                      :key="index"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                </el-form-item>

              </div>
            </el-col>
            <el-col span="8">
              <div class="reset-form-item-content">
              <el-form-item label="项目" prop="projectId" style="display: flex">
                <el-select v-model="addForm.projectId" @change="changeHandler_"
                placeholder="请选择 项目"
                style="width:100%;">
                  <el-option
                    v-for="(item, index) in projectIdList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8">
              <div class="reset-form-item-content">
              <el-form-item
                label="服务类型"
                prop="moduleType"
                style="display: flex"
              >
                <el-select
                style="width:100%;"
                placeholder="请选择 服务类型"
                  v-model="addForm.moduleType"
                  @change="orderModuleTpyeChange"
                >
                  <el-option
                    v-for="(item, index) in moduleTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
          </el-row>
          <!-- subModuleList -->

          <el-row>
            <el-col span="8">
              <div class="reset-form-item-content">
              <el-form-item
                label="子类型名称"
                prop="subModuleId"
                style="display: flex"
              >
                <el-select
                style="width:100%;"
                placeholder="请选择 子类型名称"
                  v-model="addForm.subModuleId"
                  @change="orderSubModuleIdChange"
                >
                  <el-option
                    v-for="(item, index) in subModuleList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8" v-if="addForm.moduleType !== 6">
              <div class="reset-form-item-content">
              <el-form-item label="服务地点" prop="areaId" style="display: flex">
                <el-select
                style="width:100%;"
                  v-model="addForm.areaId"
                  :value="addForm.areaId"
                  placeholder="请选择 服务地点"
                  clearable
                  ref="addConnectSelect"
                  @change="areaIdChange"
                >
                  <el-option
                    :value="addForm.areaId"
                    show-all-levels
                    :label="addForm.areaName"
                  >
                    <el-tree

                    :filter-node-method="areaFilterNode"
                      node-key="id"
                      :data="treeFormAreaData"
                      :props="treeProps"
                      :load="editAreaLazyLoadTree"
                      lazy
                      @node-click="editAreaNodeTreeClick_"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8" v-if="addForm.moduleType !== 6">
              <div class="reset-form-item-content">
              <el-form-item
                label="需求部门"
                prop="requireDeptName"
                style="display: flex"
              >
                <el-input
                style="width:100%;"
                placeholder="请选择 需求部门"
                  v-model="addForm.requireDeptName"
                  readonly
                ></el-input>
              </el-form-item>
              </div>
            </el-col>

            <el-col span="8" v-if="addForm.moduleType === 6">
              <div class="reset-form-item-content">
              <el-form-item
                label="需求部门"
                prop="deptId"
                style="display: flex"
              >
                <!-- <el-input
                style="width:100%;"
                placeholder="请选择 需求部门"
                  v-model="addForm.requireDeptName"
                  readonly
                ></el-input> -->


                <el-select v-model="addForm.deptId"
                placeholder="请选择 需求部门"
                style="width:100%;">
                  <el-option
                    v-for="(item, index) in deptList_"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8"
                v-if="addForm.moduleType === 6">
              <div class="reset-form-item-content">
              <el-form-item
                label="需求人"
                prop="requireMainId"
                style="display: flex"
              >
              <!-- <avue-input-tree style="width:100%" v-model="addForm.requireMainId" placeholder="请选择内容" :dic="requireUserList" @change="changeRequireUserHandler_"></avue-input-tree> -->

              <UserEditBox4
              @peopleChange="peopleChange"
                v-model="addForm.requireMainId"
                placeholder="请选择 需求人"
                :remainUserListInside.sync="remainUserList"
                :projectId="addForm.projectId"
                :disabled="pageMode == 0"
                :single="true"
              />
              </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col span="8"
                v-if="addForm.moduleType !== 6">
              <div class="reset-form-item-content">
              <el-form-item
                label="需求人"
                prop="requireMainId"
                style="display: flex"
              >
              <!-- <avue-input-tree style="width:100%" v-model="addForm.requireMainId" placeholder="请选择内容" :dic="requireUserList" @change="changeRequireUserHandler_"></avue-input-tree> -->

              <UserEditBox4
                v-model="addForm.requireMainId"
                placeholder="请选择 需求人"
                :remainUserListInside.sync="remainUserList"
                :projectId="addForm.projectId"
                :disabled="pageMode == 0"
                :single="true"
              />
              </el-form-item>
              </div>
            </el-col>

            <el-col span="8"
                v-if="addForm.moduleType === 6">
              <div class="reset-form-item-content">
              <!-- 设备巡检不需要期望到场时间 -->
              <el-form-item
                prop="useType"
                label="用途"
                style="display: flex"
              >

                <el-select v-model="addForm.useType"
                placeholder="请选择 紧急程度"
                style="width:100%;">
                  <el-option
                    v-for="(item, index) in useTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8">
              <div class="reset-form-item-content">
              <el-form-item
                label="紧急程度"
                prop="urgentLevel"
                style="display: flex"
              >
                <el-select v-model="addForm.urgentLevel"
                placeholder="请选择 紧急程度"
                style="width:100%;">
                  <el-option
                    v-for="(item, index) in urgentLevelList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="addForm.requireManName"
                  style="display: none"
                ></el-input>
              </el-form-item>
              </div>
            </el-col>
            <el-col span="8">
              <div class="reset-form-item-content">
              <!-- 设备巡检不需要期望到场时间 -->
              <el-form-item
                v-if="choosenModuleName !== 'EquipmentInspection'"
                prop="expectStartTime"
                label="期望到场时间"
                style="display: flex"
              >
                <el-date-picker
                style="width:100%;"
                  v-model="addForm.expectStartTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row span="24">
            <div class="reset-form-item-content">
            <el-form-item
            label-width="122px"
              label="需求描述"
              prop="description"
              style="display: flex;"
            >
              <el-input
                type="textarea"
                placeholder="请选择 需求描述"
                v-model="addForm.description"
                style="height:5rem;"
                maxlength="100"
              >
              </el-input>
              <remarkModel
                :remark.sync="addForm.description"
                ref="addFormRemarkModel"
              ></remarkModel>
            </el-form-item>
            </div>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item label="附件上传"
            label-width="110px">
                <VUpload :fileList.sync="fileList" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 特有表单项start -->
        <component
          ref="addFormExtend"
          :is="choosenModuleName"
          :projectId="addForm.projectId"
          :addFormExtend="addFormExtend"
        ></component>
      </div>
      <!-- 特有表单项end -->
      <div slot="footer">
        <el-button type="primary" @click="submitOrderCreateForm" icon="el-icon-check" size="small" :loading="submitLoading">
          保 存
        </el-button>
        <el-button @click="handleClose" size="small" icon="el-icon-close">
          取 消
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="派单"
      :visible.sync="dialogOrderAppointBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderAppointBoxVisible">
        <el-form-item label="服务班组">
        <el-select v-model="appointForm.groupName" :disabled="groupSelectDisabled" @change="appointGroupChange">
              <el-option
                v-for="(item,index) in groupList"
                :key="index"
                :label="item.groupName"
                :value="item.groupId"
              ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="转派人员" required>
          <el-select style="width: 100%" v-model="appointForm.handerId">
            <el-option
              v-for="(item, index) in userMemberList"
              :key="index"
              :label="item.realName"
              :value="item.id"
            >
                  <div style="display:flex">
                    <div style="width:50%;text-align:center;">{{item.phone?(item.realName+"("+item.phone+")"):(item.realName)}}</div>
                    <div style="flex:1;text-align:center;">{{item.workingCondition}}</div>
                    <div style="flex:1;text-align:center;">{{item.currentCount}}</div>
                  </div>

            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="备注">
          <el-input type="textarea" v-model="appointForm.remark"></el-input>
          <remarkModel
            :remark.sync="appointForm.remark"
            ref="appointFormRemarkModel"
          ></remarkModel>
        </el-form-item>

        <el-form-item label="" required>

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitAppointForm">
            保存
          </el-button>
          <el-button @click="dialogOrderAppointBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="抢单"
      :visible.sync="dialogOrderGrabbingBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderGrabbingBoxVisible">

        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="orderGrabbingForm.remark"
          ></el-input>
          <remarkModel
            :remark.sync="orderGrabbingForm.remark"
            ref="orderGrabbingFormRemarkModel"
          ></remarkModel>
        </el-form-item>

        <el-form-item label="" required>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitOrderGrabbingForm">
            保存
          </el-button>
          <el-button @click="dialogOrderGrabbingBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="催办"
      :visible.sync="dialogOrderPressingBoxVisible"
      append-to-body
    >
      <el-form label-width="100px" v-if="dialogOrderPressingBoxVisible">

        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="orderPressingForm.remark"
          ></el-input>
          <remarkModel
            :remark.sync="orderPressingForm.remark"
            ref="orderPressingFormRemarkModel"
          ></remarkModel>
        </el-form-item>

        <el-form-item label="" required>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitOrderPressingForm">
            保存
          </el-button>
          <el-button @click="dialogOrderPressingBoxVisible = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="导出数据" :visible.sync="exportExcelSelectionBoxFlag" append-to-body width="30%">
        <div style="text-align:center;padding:2rem 0;">
          <el-radio v-model="exportExcelSelectionRadio" label="1">导出全部数据</el-radio>
          <el-radio v-model="exportExcelSelectionRadio" label="2">导出已选数据</el-radio>
        </div>
        <div style="text-align:center;">
          <el-button type="primary" @click="exportExcel">确定</el-button>
          <el-button type="info" @click="exportExcelSelectionBoxFlag=false">取消</el-button>
        </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import mixin from './mixin-order-list';
export default {
  mixins: [mixin]
};
</script>

<style lang="scss" scoped>

span.el-radio-button__inner {
  border: 0 !important;
}
::v-deep .el-form-item__content{
	width: 100%;
  margin-left: 0 !important;
}
::v-deep .el-form-item--small {
	width: 100%;
  display:flex;
}
::v-deep .el-form-item {
	width: 100%;
  display:flex;
}
::v-deep .el-form-item__label{
	width: 100%;
}
::v-deep .el-textarea__inner{
	height: 5rem!important;
}
::v-deep .avue-crud__right{
  display: flex;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style >
#hr2023320 .el-drawer__body{
  height: 100%;
    overflow: scroll;
}
#hr2023320 .el-col{
       margin-bottom:-5px
}
/* ::v-deep .reset-form-item-content .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
	width: 100%;
}
::v-deep .reset-form-item-content .el-form-item--small .el-form-item__content .el-textarea__inner{
	height: 5rem;
}
::v-deep .el-dialog__wrapper .el-dialog{
  margin-top: 40px;
} */
</style>

